import React, {
  ForwardRefRenderFunction,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";

import SendCommunicationModal, {
  SendCommunicationModalHandle,
} from "../../../../../components/Generic/SendCommunicationModal";
import { useActionOrder } from "../../../../../hooks/useActionOrder";
import { Customer } from "../../../../../models/customer";
import { Job } from "../../../../../models/job";
import { UsedInEmailTemplates } from "../../../../../util/enums";

interface SendToCustomerProps {
  onRefetch?: () => void;
}

export interface SendToCustomerOrderHandle {
  onOpen: (jobId: number, job: Job, customer?: Customer) => void;
}

const SendToCustomerModalOrder: ForwardRefRenderFunction<
  SendToCustomerOrderHandle,
  SendToCustomerProps
> = (props, ref) => {
  const { onRefetch } = props;
  const { isSendingCustomerPortalLink, sendCustomerPortalLink } = useActionOrder();
  const modalRef = useRef<SendCommunicationModalHandle>(null);

  useImperativeHandle(ref, () => ({
    onOpen: (jobId: number, job: Job, customer?: Customer) => {
      modalRef.current?.onOpen({
        entityType: 'order',
        entityId: jobId,
        entity: job,
        customer,
      });
    },
  }));

  const handleSendCustomerPortalLink = (entityId: number) => {
    sendCustomerPortalLink({ jobId: entityId });
  };

  return (
    <SendCommunicationModal
      ref={modalRef}
      onRefetch={onRefetch}
      onSendCustomerPortalLink={handleSendCustomerPortalLink}
      isSendingCustomerPortalLink={isSendingCustomerPortalLink}
      usedIn={UsedInEmailTemplates.ORDERS}
    />
  );
};

export default forwardRef(SendToCustomerModalOrder);
